module.exports = __webpack_public_path__ + "assets/img/doctor.7baba561.svg";